import { KeyValue } from "@/main/models/common";
import { EntityTypeActionTypes, EntityTypeTypes } from "./entityTypeTypes";

export function getEntityType(): EntityTypeActionTypes {
	return {
		type: EntityTypeTypes.GET_ENTITY_TYPE,
	};
}

export function saveEntityType(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): EntityTypeActionTypes {
	return {
		type: EntityTypeTypes.SAVE_ENTITY_TYPE,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerEntityType(): EntityTypeActionTypes {
	return {
		type: EntityTypeTypes.RESET_REDUCER_ENTITY_TYPE,
	};
}
